// removed by extract-text-webpack-plugin
module.exports = {"text":"styles__text___38AG5","section":"styles__section___27Ip_","bold":"styles__bold___2QktC","italic":"styles__italic___Zd_4s","label":"styles__label___2hu40","tableData":"styles__tableData___1ANEN","link":"styles__link___1mXCG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/categoryTabs/thoughtsForm/answer/styles.css
// module id = 774
// module chunks = 0